import axios from 'axios'

export default {
  state: {
    companyList: [],
    companyItem: {}
  },
  mutations: {
    SET_COMPANY_LIST(state, data) {
      state.companyList = data
    },
    SET_COMPANY_ITEM(state, data) {
      state.companyItem = data
    }
  },
  actions: {
    GET_COMPANY_LIST({ commit }) {
      return axios({
        url: `/api/Company/GetCompanies`,
        method: 'get'
      }).then(response => {
        commit('SET_COMPANY_LIST', response.data)
      })
    },
    GET_COMPANY_ITEM({ commit }, id) {
      return axios({
        url: `/api/Company/GetCompany/${id}`,
        method: 'get'
      }).then(response => {
        commit('SET_COMPANY_ITEM', response.data)
      })
    },
    GET_COMPANY_ITEM_WITH_COMPLEXES({ commit }, id) {
      return axios({
        url: `/api/Company/GetCompanyWithComplexes/${id}`,
        method: 'get'
      }).then(response => {
        commit('SET_COMPANY_ITEM', response.data)
      })
    },
    SET_COMPANY({ commit, rootState }, data) {
      const sessionId = rootState.token
      return axios({
        url: `/api/Company/SetCompany/${sessionId}`,
        method: 'post',
        data
      })
        .then(response => {
          return response.data
        })
        .catch(e => {
          const { data } = e.response
          return {
            error: true,
            msg: (data || {}).message
          }
        })
    }
  },
  getters: {
    getCompanyList: state =>
      state.companyList.map(company => ({
        id: company.companyId,
        name: company.name
      }))
  }
}
